import React, {Component} from 'react';
import './styles.scss';
import Comment from "../../../common/comment/Comment";

import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    lightTooltip: {
        background: theme.palette.common.white,
        color: theme.palette.text.primary,
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
    arrowPopper: {
        '&[x-placement*="bottom"] $arrowArrow': {
            top: 0,
            left: 0,
            marginTop: '-0.9em',
            width: '3em',
            height: '1em',
            '&::before': {
                borderWidth: '0 1em 1em 1em',
                borderColor: `transparent transparent ${theme.palette.grey[700]} transparent`,
            },
        },
        '&[x-placement*="top"] $arrowArrow': {
            bottom: 0,
            left: 0,
            marginBottom: '-0.9em',
            width: '3em',
            height: '1em',
            '&::before': {
                borderWidth: '1em 1em 0 1em',
                borderColor: `${theme.palette.grey[700]} transparent transparent transparent`,
            },
        },
        '&[x-placement*="right"] $arrowArrow': {
            left: 0,
            marginLeft: '-0.9em',
            height: '3em',
            width: '1em',
            '&::before': {
                borderWidth: '1em 1em 1em 0',
                borderColor: `transparent ${theme.palette.grey[700]} transparent transparent`,
            },
        },
        '&[x-placement*="left"] $arrowArrow': {
            right: 0,
            marginRight: '-0.9em',
            height: '3em',
            width: '1em',
            '&::before': {
                borderWidth: '1em 0 1em 1em',
                borderColor: `transparent transparent transparent ${theme.palette.grey[700]}`,
            },
        },
    },
    arrowArrow: {
        position: 'absolute',
        fontSize: 7,
        width: '3em',
        height: '3em',
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: 0,
            height: 0,
            borderStyle: 'solid',
        },
    },
});


class PorcentageGraph extends Component {

    constructor(props){
        super(props);
        this.state={
            onHoverTop:false,
            onHoverPercentage:false,
            onHoverBottom:false
        }
    }

    render() {
        const { classes } = this.props;

        let marginTop = (100 - this.props.top) * 2;
        let marginBottom = (100 - this.props.bottom) * 2;
        let marginPercentage = (100 - this.props.percentage) * 2;
        let marginValue = ((100 - this.props.value) * 2)-3.5;

        return (
            <div className={"bar-section"}>
                <div className="bar">
                    <div className="bar-container"
                         style={{height: `${(this.props.top - this.props.bottom) * 2}px`, marginTop: marginTop}}/>

                    {this.props.value !== -1 &&
                    <div className={"bar-result"}
                         style={{marginTop: marginValue, color: '#dd1d21'}}>{this.props.value} %
                    </div>}

                    <Tooltip title={`${this.props.percentage} %`}
                             open={this.state.onHoverPercentage}
                             placement={"right"}
                             classes={{ tooltip: classes.lightTooltip }}>
                    <div className={'mark line'}
                         onMouseOver={()=>{this.setState({onHoverPercentage:true})}}
                         onMouseOut={()=>{this.setState({onHoverPercentage:false})}}
                         style={{
                             top: marginPercentage,
                         }}/>
                    </Tooltip>
                    <Tooltip title={`${this.props.top} %`}
                             open={this.state.onHoverTop}
                             placement={"right-top"}
                             classes={{ tooltip: classes.lightTooltip }}>
                    <div className={'mark line dark'}
                         onMouseOver={()=>{this.setState({onHoverTop:true})}}
                         onMouseOut={()=>{this.setState({onHoverTop:false})}}
                         style={{
                             top: marginTop,
                         }}/>
                    </Tooltip>
                    <Tooltip title={`${this.props.bottom} %`}
                             open={this.state.onHoverBottom}
                             placement={"right-end"}
                             classes={{ tooltip: classes.lightTooltip }}>
                    <div className={'mark line dark'}
                         onMouseOver={()=>{this.setState({onHoverBottom:true})}}
                         onMouseOut={()=>{this.setState({onHoverBottom:false})}}
                         style={{
                             top: marginBottom,
                         }}/>
                    </Tooltip>
                    {this.props.value !== -1 &&
                    <div className={'round-mark'}
                         style={{top: marginValue, backgroundColor: '#dd1d21'}}/>}
                </div>
                {this.props.comment &&

                <Comment margin={20}> {this.props.comment}</Comment>}
            </div>

        );
    }
}

PorcentageGraph.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PorcentageGraph);


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/ourPartners/components/porcentageGraph/PorcentageGraph.js